/**
 * 
 * @param {Function} currentOptionsThunk - use to get current options
 * @param {Array} matchingVariants - array of matching variants
 * @returns {Object} - object of matching variant
 */


const getClosestOptionsToCurrentlySelected = currentOptionsThunk => matchingVariants => {
  const currentOptions = currentOptionsThunk();
  const scores = matchingVariants.map(variant => variant.options.reduce((acca, cv, index) => currentOptions[index] === cv ? acca + 1 : acca, 0));
  const index = scores.indexOf(Math.max(...scores));
  return matchingVariants[index];
}

export default getClosestOptionsToCurrentlySelected